import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SectorCalendar from './sector-calendar';
import SectorCalendarDetail from './sector-calendar-detail';
import SectorCalendarUpdate from './sector-calendar-update';
import SectorCalendarDeleteDialog from './sector-calendar-delete-dialog';

const SectorCalendarRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SectorCalendar />} />
    <Route path="new" element={<SectorCalendarUpdate />} />
    <Route path=":id">
      <Route index element={<SectorCalendarDetail />} />
      <Route path="edit" element={<SectorCalendarUpdate />} />
      <Route path="delete" element={<SectorCalendarDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SectorCalendarRoutes;
